import { render } from "./ExceptionResolvedCases.vue?vue&type=template&id=997b40bc"
import script from "./ExceptionResolvedCases.vue?vue&type=script&lang=js"
export * from "./ExceptionResolvedCases.vue?vue&type=script&lang=js"

import exportComponent from "/vercel/path0/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/cases/ExceptionResolvedCases.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "997b40bc"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('997b40bc', __exports__)) {
    console.log('reload')
    api.reload('997b40bc', __exports__)
  }
  
  module.hot.accept("./ExceptionResolvedCases.vue?vue&type=template&id=997b40bc", () => {
    console.log('re-render')
    api.rerender('997b40bc', render)
  })

}


export default __exports__